import ForgotPassword from './components';

export default ForgotPassword;
